<google-map
    *ngIf="location"
    [center]="center"
    [zoom]="zoom"
    [options]="mapOptions"
    width="100%"
    height="420px"
>
    <map-circle [center]="center" [radius]="radius" [options]="circleOptions"></map-circle>
    <map-marker [position]="center" [options]="markerOptions"></map-marker>
</google-map>
